<template>
  <Modal v-model="showSessionPopup" @input="onModalInput">
    <p class="pb-2 text-2xl font-bold leading-tight">
      {{ $t('popups.session.title') }}
    </p>
    <p class="pb-5 text-sm leading-tight xl:pb-8">
      {{ $t('popups.session.description') }}
    </p>

    <Button
      type="button"
      variant="secondary"
      @click.prevent="keepSessionAlive"
    >
      {{ $t('popups.session.keepAliveButton') }}
    </Button>
  </Modal>
</template>

<script>
import SessionPopup from '~app/psp/base/session-popup.ts'
import Modal from '~brand-components/brussels/modal/modal.vue'
import Button from '~brand-components/brussels/button/button.vue'

export default SessionPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
